import { Modal, Row, Col, Button } from 'antd'

export default function ClaimFailModal (props) {
  const { actions, t } = props

  return (
    <Modal
      width={572}
      centered
      title={
        <h3 className="flex justify-center text-[20px] font-normal">
          {t?.('modal.claim_fail.title') || 'Title fallback'}
        </h3>
      }
      open={actions?.isModalOpen}
      onCancel={actions?.handleCancel}
      footer={[]}
    >
      <Row>
        <Col span={24}>
          <div className="flex items-center justify-center mt-[0px] mb-[32px] text-[16px]">
            <img
              className="w-[120px] h-[120px] mr-3"
              src="/svg/iconFailed.svg" 
              alt="failed icon"
            />
          </div>
          <div className="flex items-center justify-center font__M__plus text-[16px] ">
            {t?.('modal.claim_fail.description') || 'Description fallback'}
          </div>
        </Col>

        <Col span={24}>
          <div className="flex justify-center mt-12">
            <Button
              style={{ backgroundColor: '#FAA52C', color: '#000000' }}
              className="w-[524px] h-[48px]  rounded-[4px]"
              onClick={() => {
                actions?.handleConfirm?.()
              }}
            >
              {t?.('modal.claim_fail.confirm') || 'Confirm'}
            </Button>
          </div>
        </Col>
      </Row>
    </Modal>
  )
}
